<template>
  <div class="flex items-center flex-col mt-12">
    <h1 class="text-2xl font-bold mb-4">Page Not Found!!!</h1>
    <p class="text-xl">Go back to <router-link class="text-[blue]" to="/">HOME</router-link> </p>
  </div>
</template>
